"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDebugMode = void 0;
var constants_1 = require("./constants");
var EventLog_1 = require("./plugins/EventLog");
var object_1 = require("./utils/object");
/**
 * Check if a debug cookie is present
 */
exports.isDebugMode = typeof document !== 'undefined' && document.cookie.indexOf('__VIDEO_DEBUG__') >= 0;
var queue = [];
var Base = /** @class */ (function () {
    function Base() {
        var _this = this;
        this.name = 'Base';
        this.tealiumState = 'idle';
        this.defaultLayer = {};
        this.log = function (level, message) {
            var rest = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                rest[_i - 2] = arguments[_i];
            }
            if (!exports.isDebugMode && level === 'log') {
                return;
            }
            var fn = global.console[level];
            fn.apply(void 0, __spreadArray(["".concat(_this.name, " | ").concat(message)], rest, false));
        };
        this.info = function () {
            var arg = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                arg[_i] = arguments[_i];
            }
            var messsage = arg.shift(1);
            _this.log.apply(_this, __spreadArray(['log', messsage], arg, false));
        };
        this.warn = function () {
            var arg = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                arg[_i] = arguments[_i];
            }
            var messsage = arg.shift(1);
            _this.log.apply(_this, __spreadArray(['warn', messsage], arg, false));
        };
        this.error = function () {
            var arg = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                arg[_i] = arguments[_i];
            }
            var messsage = arg.shift(1);
            _this.log.apply(_this, __spreadArray(['error', messsage], arg, false));
        };
        this.track = function (callType, data) {
            var _a;
            if (callType === void 0) { callType = constants_1.CallType.LINK; }
            if (typeof window === 'undefined')
                return;
            var event = __assign(__assign({ call_type: callType, page_url: document.location.href }, _this.defaultLayer), data);
            // use Taq for sending events
            if (_this.tealiumState === 'useTaq') {
                // Make sure event name is added to the event
                if (!event.event_name && typeof event.event_action === 'string') {
                    event.event_name = event.event_action.replace('player-', '');
                }
                // loadclip rewrite
                if (event.event_action === 'load_media') {
                    event.event_label = 'loadclip';
                    event.event_action = 'loadclip';
                    event.event_name = 'player-loadclip';
                }
                EventLog_1.default.addToLog(event, _this);
                window.Taq = window.Taq || [];
                window.Taq.push(['setEventData', event]);
                window.Taq.push(['track', callType]);
                return;
            }
            // Todo: needs to be removed when cleaning up Taq
            // remove event action and update `player-` prefix
            if (event.event_action)
                event.event_action = null;
            if (typeof event.event_name === 'string')
                event.event_name = event.event_name.replace('player-', 'player_');
            if (!((_a = window.utag) === null || _a === void 0 ? void 0 : _a.track)) {
                _this.queue.push(__assign({ call_type: callType }, data));
                return;
            }
            _this.cleanTrackData(event);
            _this.info("send[".concat(callType, "]"), __assign({}, event));
            EventLog_1.default.addToLog(event, _this);
            window.utag.track(callType, event);
        };
        this.link = function (event) { return _this.track(constants_1.CallType.LINK, event); };
        this.view = function (event) {
            _this.track(constants_1.CallType.VIEW, __assign({ event_category: 'pageview' }, event));
        };
        this.video = function (event) { return _this.track(constants_1.CallType.VIDEO, event); };
        this.cleanTrackData = function (trackData) {
            if (trackData === void 0) { trackData = {}; }
            (0, object_1.deleteNullValues)(trackData);
            (0, object_1.toLowerCase)(trackData, constants_1.EXCLUDE_PROPERTIES_FOR_LOWERCASE);
            return trackData;
        };
        this.queue = queue;
    }
    return Base;
}());
exports.default = Base;
